interface StoredTokens {
    accessToken?: unknown;
}

interface StoredAppState {
    tokens?: StoredTokens;
}

export const hasStoredAccessToken = (serializedStore: string | null): boolean => {
    if (!serializedStore) {
        return false;
    }

    try {
        const store = JSON.parse(serializedStore) as StoredAppState;

        return typeof store.tokens?.accessToken === 'string' && store.tokens.accessToken.length > 0;
    } catch {
        return false;
    }
};
